/** @format */

import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { ProductAnalyticsService } from '@shared/data-access/analytics';
import { WINDOW } from '@shared/data-access/services';

@Component({
	selector: 'pdp-feature-change-store-button',
	styleUrl: './change-store-button.component.scss',
	templateUrl: './change-store-button.component.html',
	standalone: false
})
export class ChangeStoreButtonComponent implements OnInit {
	/** @description Resolved sku part number */
	@Input() resolvedSkuId: string;

	/** @description Array of all sku part numbers */
	@Input() productSkusPartNumber: string[];

	@Input() isSubtext = false;

	@Input() isDisabled = false;

	@Input() dataEm = '';

	storeSelectionReady = false;

	ngOnInit() {
		if (window.headerFunctions?.storeSelection) {
			this.storeSelectionReady = true;
		}
	}

	constructor(
		@Inject(WINDOW) protected window: Window,
		private productAnalyticsService: ProductAnalyticsService
	) {}

	/**
	 * @description look to see if there is a resolved sku,
	 * if there is need to pass an array of all the sku part numbers as well as the resolved sku part number,
	 * if sku is not resolved, pass an array of all the sku part numbers
	 */
	openChangeStorePanel() {
		const storeSelectionValues = this.resolvedSkuId
			? { skusArr: this.productSkusPartNumber, selectedSkuVal: this.resolvedSkuId }
			: { skusArr: this.productSkusPartNumber };
		if (window.headerFunctions?.storeSelection) {
			this.window.headerFunctions.storeSelection(storeSelectionValues);
		}
		if (this.dataEm) {
			this.productAnalyticsService.triggerDataEmCall(this.dataEm);
		}
	}

	@HostListener('window:HeaderServices:StoreSelection:Ready', ['$event'])
	public onStoreSelectionReady(customEvent: CustomEvent): void {
		if (customEvent) {
			this.storeSelectionReady = true;
		}
	}
}
